'use strict';

var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var PriceRow = require('./PriceRow.js');
var LendingPromoRow = require('./LendingPromoRow.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PriceDetails = function PriceDetails(_ref) {
  var subtotal = _ref.subtotal,
      discount = _ref.discount,
      discountName = _ref.discountName,
      taxName = _ref.taxName,
      taxRate = _ref.taxRate,
      taxAmount = _ref.taxAmount,
      totalAmount = _ref.totalAmount,
      lendingPromoAmount = _ref.lendingPromoAmount;
  var taxRateDisplay = taxRate ? "(".concat((taxRate * 100).toFixed(4), "%)") : '';
  return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(PriceRow, {
    label: "Subtotal",
    amount: subtotal
  }), Boolean(discount) && discount > 0 ? React__default["default"].createElement(PriceRow, {
    label: discountName || 'Discount',
    amount: discount,
    negative: true
  }) : null, Boolean(taxAmount) && taxAmount > 0 ? React__default["default"].createElement(PriceRow, {
    label: "".concat(taxName || 'Tax', " ").concat(taxRateDisplay),
    amount: taxAmount
  }) : null, React__default["default"].createElement(PriceRow, {
    label: "Total payment",
    amount: totalAmount,
    labelVariant: "subtitle1",
    currencyVariant: "subtitle1"
  }), ObjectHelper.isPresent(lendingPromoAmount) && React__default["default"].createElement(LendingPromoRow, {
    amount: lendingPromoAmount
  }));
};

module.exports = PriceDetails;
